// extracted by mini-css-extract-plugin
module.exports = {"emptyListMessage":"styles_emptyListMessage__KFh5X","colorWhite7":"styles_colorWhite7__2u5LU","colorWhite8":"styles_colorWhite8__30IyW"};